export class RelProgettoStatiIN {
    idProgetto: number
    idTabStatiProject: number
    idUser: number
    note: string
}
